/** The toast of a send (JBWEB-1282): the counts first, then a line per company left aside. */
const InvoiceMailReport = ({ lines }) => (
  <div className="flex flex-col gap-1">
    {lines.map((line, index) => (
      <div key={index} className={index === 0 ? 'font-medium' : 'text-sm'}>
        {line}
      </div>
    ))}
  </div>
);

export default InvoiceMailReport;
